import { CheckIcon, TriangleAlertIcon } from 'lucide-react'

import { cn } from '@/utils'

export type StepState = 'pending' | 'done' | 'warning'

interface StepRailProps {
  step: number
  state: StepState
  isFirst?: boolean
  isLast?: boolean
}

// The segment above the badge doubles as the header's top padding, keeping the line unbroken.
export const StepRail = ({
  step,
  state,
  isFirst = false,
  isLast = false,
}: StepRailProps) => (
  <div className="flex flex-col items-center">
    <span aria-hidden className={cn('h-2.5 w-px', !isFirst && 'bg-border')} />

    <span
      className={cn(
        'flex size-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold',
        state === 'done' && 'bg-brand text-white',
        state === 'warning' && 'bg-amber-100 text-amber-700',
        state === 'pending' && 'bg-neutral-200 text-muted-foreground',
      )}
    >
      {state === 'done' ? (
        <CheckIcon className="size-3.5" />
      ) : state === 'warning' ? (
        <TriangleAlertIcon className="size-3.5" />
      ) : (
        step
      )}
    </span>

    {!isLast && <span aria-hidden className="w-px flex-1 bg-border" />}
  </div>
)
